import React from "react";
import { useErrorStore } from "./stores/errorStore";

// Компонент вікна помилки
export const ErrorNotification = () => {
  const { isVisible, error, hideError } = useErrorStore();

  // Якщо вікно невидиме, нічого не рендеримо
  if (!isVisible) {
    return null;
  }

  return (
    <div className="error-notification" key={error.id}>
      <div className="error-body">
        <p>
          <span>Помилка:</span> {error.message}
        </p>
      </div>
      <div className="error-sidebar">
        <button onClick={hideError} className="close-btn">
          &times;
        </button>
        <div className="timer-container">
          <svg viewBox="0 0 36 36">
            <circle
              className="timer-circle"
              cx="18"
              cy="18"
              r="15.9"
              fill="transparent"
              strokeWidth="4"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ErrorNotification;
